import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import ar from './ar.json';
import he from './he.json';

export const LANGUAGES = {
    en: { name: 'English', dir: 'ltr', nativeName: 'English' },
    ar: { name: 'Arabic', dir: 'rtl', nativeName: 'العربية' },
    he: { name: 'Hebrew', dir: 'rtl', nativeName: 'עברית' },
} as const;

export type LanguageCode = keyof typeof LANGUAGES;

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ar: { translation: ar },
            he: { translation: he },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'ar', 'he'],
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

// Update document direction based on language
i18n.on('languageChanged', (lng) => {
    const language = LANGUAGES[lng as LanguageCode];
    if (language) {
        document.documentElement.dir = language.dir;
        document.documentElement.lang = lng;
    }
});

export default i18n;
